<template>
  <fragment>
    <HcTabela
      :mensagem-tabela-vazia="mensagemTabelaVazia"
      :colunas="colunas"
      :itens="pagina.content"
      :ordenacao="pagina.sort"
      :mantem-estado="mantemEstado"
      :small="small"
      @ordenar="onOrdenar($event)"
    >
      <template slot="thead">
        <slot name="thead" />
      </template>
      <template slot="tbody">
        <slot name="tbody" />
      </template>

      <template slot="tr" slot-scope="props">
        <slot name="tr" :item="props.item" :row-id="props.rowId" />
      </template>

      <template slot="tfoot">
        <slot name="tfoot" />
      </template>
    </HcTabela>

    <HcPaginacao
      :pagina-ativa="pagina.number"
      :total-paginas="pagina.totalPages"
      :total-elementos="pagina.totalElements"
      :total-elementos-pagina="pagina.numberOfElements"
      :tamanho-pagina="pagina.pageSize"
      :mantem-estado="mantemEstado"
      @trocar-pagina="$emit('trocar-pagina', $event)"
    />
  </fragment>
</template>

<script>
import HcTabela from "./Tabela";
import HcPaginacao from "./Paginacao";

export default {
  name: "HcTabelaPaginada",
  components: {
    HcTabela,
    HcPaginacao
  },
  props: {
    titulo: {
      type: String,
      default: "Resultado"
    },
    semTitulo: {
      type: Boolean,
      default: false
    },
    colunas: {
      type: Array,
      default: () => []
    },
    totalRegistrosText: {
      type: String,
      default: "Total de registros encontrados"
    },
    mensagemTabelaVazia: {
      type: String,
      default: "Nenhum registro encontrado."
    },
    pagina: {
      type: Object,
      default: () => {
        return {
          number: 0,
          numberOfElements: 0,
          totalElements: 0,
          content: [],
          pageSize: 0,
          totalPages: 0,
          sort: null
        };
      }
    },
    mantemEstado: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    temPaginacao
  },
  methods: {
    onOrdenar
  }
};

function temPaginacao() {
  return this.pagina.totalPages > 1;
}

function onOrdenar(ordenacao) {
  let ordemString = null;

  if (ordenacao && ordenacao.ordem) {
    ordemString = `${ordenacao.campo},${ordenacao.ordem}`;
  }

  this.$emit("ordenar", ordenacao);
  this.$emit("ordenar:string", ordemString);
}
</script>
